import { Pipe, PipeTransform } from '@angular/core';

const statuses = [
  ['pre_transit', 'no_info'],
  ['delivery_in_progress', 'in_transit', 'customs_clearance'],
  ['return_to_sender', 'expired', 'transit_limit_exceeded'],
  ['unsuccessful_delivery', 'error', 'exception', 'cancelled'],
  ['delivered', 'available_for_pickup']
];

@Pipe({
  name: 'trackingItemStatus',
  pure: true
})
export class TrackingItemStatusPipe implements PipeTransform {
  transform(numberStatus, status, index): any {
    return typeof index === 'number'
      ? statuses.findIndex((item) => item.includes(numberStatus)) === index
      : statuses.findIndex((item) => item.includes(numberStatus)) ===
        statuses.findIndex((item) => item.includes(status))
      ? numberStatus
      : status;
  }
}
